import { sendAnalytics } from '@audio-network/analytics'
import { Cart } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'

import { addToCart } from '@/services/cartService'
import sessionStore from '@/stores/sessionStore'
import { redirectToHref } from '@/utils/window'

import { AddToCartProps } from './AddToCart.types'

const AddToCart = ({
	track,
	source,
	...props
}: AddToCartProps): JSX.Element => {
	const user = sessionStore((state) => state.session?.user)
	const { t } = useTranslation(['trackrow'])

	const handleClick = async (): Promise<void> => {
		const updatedCart = await addToCart(track.id, user.id)

		if (updatedCart) {
			sendAnalytics({
				noun: 'Add to Cart',
				pastTenseVerb: 'Clicked',
				eventParameters: {
					TrackId: track.id,
					TrackTitle: track.title,
					AlbumNo: track.album.number,
					CartCount: updatedCart?.itemsCount,
					TrackSource: source,
					Genre: track.album.genre,
					Catalogue: track.album.catalogue.name,
				},
			})
			redirectToHref('/cart')
		}
	}

	return (
		<Cart
			title={t('track-actions.add-to-cart')}
			onClick={handleClick}
			{...props}
		/>
	)
}

export default AddToCart
